// extracted by mini-css-extract-plugin
export default {"history":"SearchHistory_history__1J+vC","history__list":"SearchHistory_history__list__pw3vJ","history__item":"SearchHistory_history__item__1O+oK"};